import { render, staticRenderFns } from "./time-box-reward.vue?vue&type=template&id=ab02e782&scoped=true"
import script from "./time-box-reward.vue?vue&type=script&lang=js"
export * from "./time-box-reward.vue?vue&type=script&lang=js"
import style0 from "./time-box-reward.vue?vue&type=style&index=0&id=ab02e782&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab02e782",
  null
  
)

export default component.exports